export const COLORS = {
  lightSlateGray: '#CFD8DCD9',
  blueGrey600: '#546E7A',
  alabaster: '#F9FAFB',
  amethyst: '#919EAB',
  antiqueWhite: '#FFE7D9',
  aquaGreen: '#34D399',
  backgroundLightBlue: '#5FB2E029',
  ballBlue: '#18a2dc1f',
  black: '#000000',
  blackSkeleton: '#D9D9D9',
  blazeOrange: '#FD6F08',
  blueGrey200: '#B0BEC5',
  blueUva: '#232D4B',
  brightCeruleanA14: '#18a2dc14',
  brightCeruleanA29: '#18A2DC29',
  cadetGrey: '#919eab3d',
  carrouselButton: '#7b7b7b3d',
  cascade: '#919eab52',
  circleVerticalIkigai: '#B0B9C0',
  coolGrey: '#919eabcc',
  coralRed: '#E53935',
  coralRedVariant: '#EF5350',
  crimsonRed: '#C62828',
  curiousBlue: '#18A2DC',
  darkBlue: '#172738',
  daySkyBlueA80: '#94cbff80',
  deepPink: '#FC248D',
  deepLilac: '#B39DDB',
  ebonyClay: '#212B36',
  firstGenAIButton: '#8A2BE2',
  floatingButton: '#00000040',
  frenchRose: '#F25A8C',
  frenchRoseA29: '#f25a8c29',
  frenchRoseVariant: '#F57BA3',
  carmineRose: '#C1466E',
  silver: '#BDBDBD',
  freshGreen: '#66BB6A',
  greenPathCourses: '#45963B',
  greenPeas: '#68d75b',
  greenTeal: '#10B981',
  intersectCircleBackgroundIkigai: '#FECC01',
  intersectCircleBorderIkigai: '#F7A70D',
  jungleMist: '#C4CDD5',
  lightBlue: '#5fb2e03d',
  lightBlue05: '#DFF0F9',
  lightBlueTranslucent: '#dff0f94d',
  listSelected: '#0000000A',
  main: '#172638',
  mirage: '#161C24',
  cometGrey: '#454F5B',
  sapphire: '#1E51A4',
  periwinkle: '#B8C8E1',
  champagne: '#FFF9F5',
  tangerine: '#F17D1F',
  marigold: '#FFA000',
  mistBlue: '#637381',
  moonBlue: '#104799',
  moonBlueA29: '#10479929',
  none: 'none',
  orangeUva: '#E47404',
  pictonBlue: '#5FB2E0',
  pictonBlueLight: '#BFE0F3',
  platinum: '#DFE3E8',
  prussianBlue: '#172638',
  purpleHeart: '#6D28D9',
  purplishPink: '#E055AE',
  redViolet: '#D82B9A',
  contrastRedViolet: '#B00078',
  secondHumanContrast: '#D02B93',
  secondGenAIButton: '#5761ED',
  skillTagGreen: '#B1EBAA80',
  springWood: '#F4F6F8',
  thirdGenAIButton: '#00BFFF',
  tooltipRankingList: '#454F5B',
  topListColorPrevious: '#406CAD',
  transparent: 'transparent',
  vividTangerine: '#FFA48D',
  watermelon: '#fa4447',
  waxFlower: '#FFBF92',
  whiteSmoke: '#f4f6f8',
  yaleBlue: '#104799',
  white: '#FFFFFF',
  firebrick: '#D12C24',
  twoAuthentication: '#B1EBAA',
  neonGreen: '#B1EBAA80',
  orangeStar: '#F7A70D',
  moneyIncreaseIcon: '#2E7D32',
  moneyDecreaseIcon: '#CC3A35',
  moneyDecreaseIconBackground: '#FFA4A1',
  emeraldFern: '#2E7D32',
  chartAmber: '#FFB300',
  chartLightBlue: '#88A3CC',
  chartPinkLight: '#E880C2',
  chartBlueGray: '#8aa5cd',
  chartDarkBlue: '#3d6aac',
  chartPeriwinkle: '#5470C6',
  chartMagenta: '#D54878',
  chartCornflowerBlue: '#5B8FF9',
  donutBlueSoft: '#839BC9',
  donutPinkLight: '#F4B5C2',
  donutSkyLight: '#ADC3E3',
  donutAmberLight: '#F8D583',
  donutMagenta: '#D92DA1',
  donutLilac: '#D0C6E3',
  donutTeal: '#0097A7',
  donutPurple: '#9575CD',
  donutOrange: '#FF8F00',
  chartBorderGray: '#E5E7EB',
  chartTextGray: '#6B7280',
  chartGridGray: '#E0E0E0',
  chartDarkGray: '#374151',
  chartTooltipDark: '#616161E5',
  chartPeriwinkleA08: 'rgba(84, 112, 198, 0.8)',
  chartPeriwinkleA01: 'rgba(84, 112, 198, 0.1)',
  chartPeriwinkleA06: 'rgba(84, 112, 198, 0.6)',
  chartMagentaA08: 'rgba(213, 72, 120, 0.8)',
  chartMagentaA01: 'rgba(213, 72, 120, 0.1)',
  chartMagentaA06: 'rgba(213, 72, 120, 0.6)',
  chartCornflowerBlueA08: 'rgba(91, 143, 249, 0.8)',
  chartCornflowerBlueA01: 'rgba(91, 143, 249, 0.1)',
  chartCornflowerBlueA06: 'rgba(91, 143, 249, 0.6)',
  titlesStudentOverview: '#1D1D1B',
  linearProgressOverview: '#1F2937',
  backgroundFilterObligatory: '#CFDAEB',
  skillsGapsSpecialized: '#7091C2',
  skillsGapsHuman: '#F79CBA',
  iconEmptyStateNewStudentOverview: '#455A64',
  checkboxProficiencyLevels: '#0000008F',
  starsProficiencyLevels: '#FFB400',
  backgroundNewLoader: '#0000001f',
  modalPlarTitle: '#54585A',
  modalPlarSubtitle: '#888B8D',
  xIconModal: '#0000008f',
  senecaRed: '#DA291C',
  senecaGray: '#54585A',
  sidebarSelected: '#ECEFF1',
  menuCourseCollection: '#F5F5F5',
  iconMenuCourseCollection: '#37474F',
  trackScrollColumnKanban: '#EEEEEE',
  thumbScrollColumnKanban: '#BDBDBD',
  fieldsetStandardBorder: '#0000006b',
  hoverMenuCollection: '#0000000a',
  spaceDashboardOutlinedIcon: '#263238',
  iconMenuEditCollection: '#D32F2F',
  placeHolderHeaderCell: '#00000080',
  occupationComparisonGreenBackground: '#C8E6C9',
  occupationComparisonGreenText: '#1B5E20',
  occupationComparisonOrangeBackground: '#FFE0B2',
  occupationComparisonOrangeText: '#BF360C',
  occupationComparisonRedBackground: '#FECDD2',
  occupationComparisonRedText: '#B71C1C',
  occupationComparisonDisabledBackground: 'rgba(0, 0, 0, 0.12)',
  filterChipUnselectedBackground: 'rgba(0, 0, 0, 0.08)',
  filterChipUnselectedHoverBackground: 'rgba(0, 0, 0, 0.16)',
  chatBotBrandColor: '#2d6cdf',
  hoki: '#607D8B',
  lightBlueGrey: '#cfd8dc',
  skeletonLP: '#CFD8DC',
  ikigaiChip: '#7C4DFF',
  royalBlue: '#1565C0',
  burnOrange: '#E65100',
  amberOrange: '#FB8C00',
  chipCloseIcon: '#B7C7E0',
  emptyStateIconBg: '#CFD8DC',
  paleSkyBlue: '#EBF4FF',
  paleMint: '#E8F5E9',
  palePink: '#FFEBEE',
  peachCream: '#FFF3E0',
  inputBorder: '#00000061',
  contactInfoTitle: '#808185',
};

export type IColors = typeof COLORS;
